<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="drawer"
    :location="$vuetify.display.mobile ? 'top' : 'left'"
    theme="dark"
    width="300"
    :style="drawer ? 'margin-top:16px;' : 'margin-top:0px;'"
  >
    <!-- API TEST -->
    <!-- <v-btn light to="/api">API</v-btn> -->
    <!-- END API TEST -->
    <v-list density="compact" class="">
      <template v-for="(item, rootIndex) in items" :key="rootIndex">
        <!-- Group with sub items -->
        <v-list-group v-if="item.items" :group="item.group" :prepend-icon="item.icon" no-action>
          <template #activator="{ props }">
            <v-list-item v-bind="props" ripple>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>
          <!-- Sub item -->
          <v-list-item
            v-for="(subItem, i) in item.items"
            :key="i"
            :to="!subItem.external ? subItem.href : null"
            :href="subItem.external ? subItem.href : null"
            ripple
          >
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- Subheader -->
        <v-list-subheader v-else-if="item.header" class="mt-4">
          {{ item.header }}
        </v-list-subheader>

        <!-- Top-level item -->
        <v-list-item
          v-else
          :to="!item.external ? item.href : null"
          :href="item.external ? item.href : null"
          rel="noopener"
          ripple
        >
          <template #prepend>
            <!-- Apply the color prop directly to v-icon -->
            <v-icon color="white" :icon="item.icon"></v-icon>
          </template>
          <v-list-item-title>
            {{ item.title }}
            <template v-if="item.count">
              <span v-if="item.href === '/groups'" class="ml-1 text-grey"
                >({{ groups.length }})</span
              >
              <span v-if="item.href === '/watchlists'" class="ml-1 text-grey"
                >({{ watchlists.length }})</span
              >
              <span v-if="item.href === '/email_alerts'" class="ml-1 text-grey"
                >({{ emailAlerts.length }})</span
              >
              <span v-if="item.href === '/tracked_backtests'" class="ml-1 text-grey"
                >({{ trackedBacktests.length }})</span
              >
            </template>
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Pinia stores
import { mapWritableState } from 'pinia'
import { useAppStore, useUserStore } from '@/store'
// Static data
import menuItems from '@/data/menu-items'

export default {
  data: () => ({
    items: menuItems
  }),

  computed: {
    ...mapWritableState(useUserStore, ['groups', 'emailAlerts', 'trackedBacktests', 'watchlists']),
    ...mapWritableState(useAppStore, ['drawer'])
  }
}
</script>

<style>
.v-list-item-title {
  color: #fff;
}
</style>
